import { BaseLogger } from '../BaseLogger';

export class DevelopmentLogger extends BaseLogger {
  constructor(type, isLocalViewer, isBranch) {
    super(isLocalViewer, isBranch);
    this.type = type;
  }

  log(event, ...params) {
    if (!this.isLogNeeded(event, ...params)) {
      return;
    }
    const transformedParams = [event, ...params].reduce(toString, '');
    console.groupCollapsed(`${this.type} Dev logger`);
    console.log(
      `Called with:%c\n${transformedParams}`,
      'color: green; font-weight: bold',
    );
    console.groupEnd();
  }
}

const getParamDisplay = (param) =>
  param instanceof Function
    ? `function::${param.name}`
    : `${typeof param}::${JSON.stringify(param, null, 2)}`;

const toString = (accumulator, param) =>
  `${accumulator ? accumulator + ',' : accumulator} \n${getParamDisplay(
    param,
  )}`;
